import * as React from 'react';

type CheckoutBreakdownHoverProps = {
  priceHoverClass: string;
  planName: string;
  seatCount: number;
  seatsTotal: string;
  seatPrice: number;
  platformPrice: number;
  platformTotal: string;
  checkoutTotal: string;
  isMonthlyPayPeriod: boolean;
  paidPlanBonus: string;
};

export const CheckoutBreakdownHover = ({
  priceHoverClass, planName, seatCount, seatsTotal, platformTotal, checkoutTotal,
  isMonthlyPayPeriod, seatPrice, platformPrice, paidPlanBonus,
}: CheckoutBreakdownHoverProps) => {
  const lineItems = [
    {
      name: 'Users',
      price: seatsTotal,
      breakdown: `${seatCount} users x $${seatPrice}/mo${isMonthlyPayPeriod ? '' : ' x 12 months'}`,
    },
    {
      name: 'Platform Fee',
      price: platformTotal,
      breakdown: `$${platformPrice}/mo${isMonthlyPayPeriod ? '' : ' x 12 months'}`,
    },
    {
      name: `${paidPlanBonus} Account Balance*`,
      price: 'FREE',
    },
  ];

  const hoverLineItems = lineItems.map((lineItem, idx) => {
    if (lineItem.price !== '$0') {
      return (
        <tr key={lineItem.name}>
          <td>
            <span>{lineItem.name}</span>
            <br />
            <span className="fsz-10" style={{ opacity: '.6' }}>{lineItem.breakdown}</span>
          </td>
          <td className={idx === lineItems.length - 1 ? 'last-line-item' : ''}>{lineItem.price}</td>
        </tr>
      );
    }
    return <></>;
  });

  return (
    <span id="checkout-breakdown-hover" className={priceHoverClass}>
      <table>
        <thead>
          <tr>
            <td>{`${planName} Plan ${isMonthlyPayPeriod ? 'Monthly' : 'Annually'}:`}</td>
            <td />
          </tr>
        </thead>
        <tbody>
          {hoverLineItems}
          <tr className="gold bold-800">
            <td>
              <span className="bright-yellow bold-800">Due Today</span>
            </td>
            <td>
              <span className="bright-yellow bold-800">{checkoutTotal}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </span>
  );
};
